import withErrorWrapper from '../../../hoc/WithErrorWrapper';
import view from './BureauReportView';

export default withErrorWrapper(view);
